/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Picker_Checkout_OnlyInputs */

const en_picker_checkout_only = /** @type {(inputs: Picker_Checkout_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-out only`)
};

/**
* | output |
* | --- |
* | "Check-out only" |
*
* @param {Picker_Checkout_OnlyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const picker_checkout_only = /** @type {((inputs?: Picker_Checkout_OnlyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Picker_Checkout_OnlyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_picker_checkout_only(inputs)
});